import { stringify } from "@coverme/querystring";
import Axios from "axios";

/***
 * Gets matching persons
 * @param formData an object containing firstName, middleInitial, nameSuffix, lastName, socialSecurityNumber, dateOfBirth, mrn, documentType, documentId.
 * @returns {AxiosPromise<any>} Promise of matching persons.
 */
export function getMatchingPerson(customerId, formData) {
    const queryString = stringify(formData);
    return Axios.get(`/api/customer/${customerId}/persons/matches?${queryString}`);
}

export function getMatchingPersonBySsn(customerId, formData) {
    const queryString = stringify(formData);
    return Axios.get(`/api/customer/${customerId}/persons/matches/ssn?${queryString}`);
}
